import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import RichText from "common/blocks/RichText";
import { ResolvedRichText } from "resolvers/data/richTextResolver";

import styles from "./QualityWidget.module.scss";

const cx = classNames.bind(styles);

export type QualityWidgetProps = {
    title?: string;
    text?: ResolvedRichText;
    buttonText?: string;
    list?: ResolvedRichText;
    link?: string;
};

const QualityWidget = ({ text, title, buttonText, link, list }: QualityWidgetProps) => {
    if (!text && !title && !buttonText && !link && !list) return null;
    return (
        <div className={cx("qualityWidget")}>
            {title && (
                <div className={cx("titleRow")}>
                    <h2 className={cx("title")}>{title}</h2>
                </div>
            )}
            {text && (
                <div className={cx("text")}>
                    <RichText {...text} />
                </div>
            )}
            {link && buttonText && (
                <div className={cx("buttonRow")}>
                    <Button href={link} target="_blank" theme="textLink" ariaLabel={buttonText}>
                        {buttonText}
                    </Button>
                </div>
            )}
            {list && (
                <div className={cx("highlights")}>
                    <RichText {...list} />
                </div>
            )}
        </div>
    );
};

export default QualityWidget;
